export const ENV = import.meta.env?.VITE_ENV || 'local'
export const VERSION = import.meta.env?.VITE_APP_VERSION || 'dev'
export const LAST_COMMIT_HASH = import.meta.env?.VITE_LAST_COMMIT_HASH || ''
export const RELEASE_TIMESTAMP = import.meta.env?.VITE_RELEASE_TIMESTAMP || ''
